import {AirportCodeEnum} from "./airport-code.enum";
import {IataCodeEnum} from "./iata-code.enum";

export class SpecialPointOfSaleService {
    isSpecialAirport(locationOid):boolean {
        return (locationOid == AirportCodeEnum.MIAMI_AIRPORT
            || locationOid == AirportCodeEnum.CANCUN_AIRPORT
            || locationOid == AirportCodeEnum.ORLANDO_AIRPORT);
    }

    showIndicationsPhone(locationOid, isPointOfSale):boolean {
        return !isPointOfSale && this.isSpecialAirport(locationOid);
    }

    isMiamiAirport(locationOid):boolean {
        return locationOid == AirportCodeEnum.MIAMI_AIRPORT;
    }

    isOrlandoAirport(locationOid):boolean {
        return locationOid == AirportCodeEnum.ORLANDO_AIRPORT;
    }

    isCancunAirport(locationOid):boolean {
        return locationOid == AirportCodeEnum.CANCUN_AIRPORT;
    }

    getIataCode(locationOid):string {
        switch (locationOid) {
            case AirportCodeEnum.MIAMI_AIRPORT: return IataCodeEnum.MIAMI_IATA_CODE;
            case AirportCodeEnum.CANCUN_AIRPORT: return IataCodeEnum.CANCUN_IATA_CODE;
            case AirportCodeEnum.ORLANDO_AIRPORT: return IataCodeEnum.ORLANDO_IATA_CODE;
            default: return "";
        }
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/pointOfSale/special-point-of-sale.service.ts